module.exports = __webpack_public_path__ + "LU.png?dd87418a7c01585848dd2a2981cf0176";